import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { editarUsuario, obterUsuarioPorId, listarUsuariosDistribuidor, atualizarUsuarioDistribuidor } from "../services/api";
import { portalDistribuidor } from "../utils/portalModo";
import CadastroUsuario from "./CadastroUsuario";

const EditarUsuario = ({ token }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const distribuidor = portalDistribuidor();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (distribuidor) {
          const response = await listarUsuariosDistribuidor(token);
          const lista = Array.isArray(response.data) ? response.data : [];
          setInitialData(lista.find((u) => String(u.id) === String(id)) || null);
          return;
        }
        const response = await obterUsuarioPorId(id, token);
        setInitialData(response.data);
      } catch (error) {
        console.error("Erro ao carregar os dados do usuário:", error);
      }
    };
    fetchData();
  }, [id, token, distribuidor]);

  const handleEditSubmit = async (data, token) => {
    try {
      if (distribuidor) await atualizarUsuarioDistribuidor(id, data, token);
      else await editarUsuario(id, data, token);
      navigate('/usuarios');

    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
      const msg =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string" ? error.response.data : null) ||
        "Erro ao atualizar usuário.";
      alert(msg);
    }
  };

  if (!initialData) return <div>Carregando...</div>;

  return (
    <CadastroUsuario
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
      audiencia={distribuidor ? "distribuidor" : "revenda"}
    />
  );
};

export default EditarUsuario;
